module.exports = __webpack_public_path__ + "img/product12.67327772.png";